import {
  ComplianceExtraFieldsConfigFragment,
  DefaultComplianceSettingsCreateModalQueryDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { DefaultComplianceSettingsModal } from 'modules/finance/activities/defaultComplianceSettings/components/DefaultComplianceSettingsModal'
import { useDefaultComplianceSettingsForm } from 'modules/finance/activities/defaultComplianceSettings/hooks/useDefaultComplianceSettingsForm'

interface ModalContentProps {
  onClose: () => void
  refetchQuery?: string
  systemComplianceExtraFields: ComplianceExtraFieldsConfigFragment[]
  loading: boolean
}

const ModalContent = ({
  onClose,
  refetchQuery,
  systemComplianceExtraFields,
  loading,
}: ModalContentProps) => {
  const {
    form,
    loading: submitting,
    resetForm,
  } = useDefaultComplianceSettingsForm({
    refetchQuery,
    onSuccess: () => {
      resetForm()
      onClose()
    },
    successMessage: i18n.t('finance.compliance_extra_field_default_settings.modal.new.success'),
    systemComplianceExtraFields,
  })

  const userClose = () => {
    resetForm()
    onClose()
  }

  return (
    <DefaultComplianceSettingsModal
      isOpen
      onClose={userClose}
      onSubmit={() => form.handleSubmit()}
      title={i18n.t('finance.compliance_extra_field_default_settings.modal.new.title')}
      description={i18n.t('finance.compliance_extra_field_default_settings.modal.new.description')}
      submitButtonText={i18n.t('common.create')}
      form={form}
      systemComplianceExtraFields={systemComplianceExtraFields}
      loading={loading}
      submitting={submitting}
    />
  )
}

export const DefaultComplianceSettingsCreateModal = ({
  isOpen,
  onClose,
  refetchQuery,
}: {
  isOpen: boolean
  onClose: () => void
  refetchQuery?: string
}) => {
  const { data, loading } = useQuery(DefaultComplianceSettingsCreateModalQueryDocument, {
    skip: !isOpen,
  })
  const systemComplianceExtraFields = data?.finance.systemComplianceExtraFields ?? []

  if (!isOpen || !data) {
    return null
  }

  return (
    <ModalContent
      onClose={onClose}
      refetchQuery={refetchQuery}
      systemComplianceExtraFields={systemComplianceExtraFields}
      loading={loading}
    />
  )
}
